import { gql } from '@common/hooks';

export const WorksMembershipCreation = gql`
  mutation WorksMembershipCreation($input: CreateWorksMembershipInput!) {
    createWorksMembership(input: $input) {
      worksMembership {
        id
      }
    }
  }
`;

export type WorksMembershipCreationResponse = {
  createWorksMembership: {
    worksMembership: {
      id: string;
    };
  };
};
